import constants from '@/constants'
import i18next from 'i18next'

export default function buildImportStructure(rev) {
  return {
    nameTitle: i18next.t('rev_detail.rev_name_title'),
    name: rev.name,
    //
    typeTitle: i18next.t('rev_detail.rev_type_title'),
    type: rev.revType,
    //
    site: i18next.t('revPowerPointImport.site', { site: rev.site }),
    //
    createdAt: i18next.t('revPowerPointImport.created_at', {
      date: rev.createdAt,
    }),
    completedAt: i18next.t('revPowerPointImport.completed_at', {
      date: rev.completedAt,
    }),
    implementedAt: i18next.t('revPowerPointImport.implemented_at', {
      date: rev.implementedAt,
    }),
    impactValidatedAt: i18next.t('revPowerPointImport.impactValidated_at', {
      date: rev.impactValidatedAt,
    }),
    //
    categories: i18next.t('revPowerPointImport.categories', {
      categories: rev.categories,
    }),
    //
    country: i18next.t('revPowerPointImport.country', {
      country: rev.country,
    }),
    //
    status: i18next.t('revPowerPointImport.status', { status: rev.status }),
    //
    author: i18next.t('revPowerPointImport.author', { author: rev.author }),
    //
    coach: i18next.t('revPowerPointImport.coach', { coach: rev.coach }),
    //
    team: i18next.t('revPowerPointImport.collaborators', {
      collaborators: rev.team,
    }),
    //
    problemTitle: i18next.t('rev_detail.problem_title'),
    problem: rev.problem,
    //
    solutionTitle: i18next.t('rev_detail.solution_title'),
    solution: rev.solution,
    //
    impactTitle: i18next.t('rev_detail.impact_title'),
    //
    impactBenefitsTitle: i18next.t('rev_detail.estimate_title'),
    totalImpactValidatedTitle: i18next.t(
      'revPowerPointImport.total_impact_validated_title'
    ),
    impactBenefits: rev.impactBenefits,
    emptyImpactBenefits: rev.emptyImpactBenefits,
    //
    totalImpactTitle: i18next.t('rev_detail.total_impact_title'),
    totalImpact: rev.totalImpact,
    //
    impactTimeFrameTitle: i18next.t('rev_detail.impact_time_frame_title'),
    impactTimeFrame: rev.impactTimeFrame,
    //
    revMedia: rev.revMedia,
    solutionMedia: rev.solutionMedia,
    //
    logo: constants.logoImageBase64,
  }
}
